import apiClient from '@/api/index'
export const learningModule = {
    namespaced: true,

    state:() => ({
        loading: true,
        chapters: null,
        polls: null,
        test: null,
        testError: '',
        poll_progress_id: null,
        points: null,
        total_points: null,
        projects: null,
        selected_project: null,
        is_succeded: false,
    }),

    mutations: {
        setChapters(state, data) {
            state.chapters = data
        },

        setPolls(state, data) {
            state.polls = data
        },

        setTest(state, data) {
            state.test = data
        },

        setPollProgressId(state, data) {
            state.poll_progress_id = data
        },

        setProjects(state, data) {
            state.projects = data['project']
            const choices = state.projects?.choices || [];
            state.selected_project = choices.find(choice => choice.value === state.selected_project)?.value
                ?? choices.find(choice => choice.checked)?.value ?? choices[0]?.value ?? null;
        },

        changeProject(state, data) {
            state.selected_project = data
        }

    },

    actions: {
        getChapters({ state, commit }) {
            apiClient.get(`/projects/${state.selected_project}/chapters/`, {
                headers: {
                    Authorization: 'Token ' + localStorage.getItem('token')
                }
            })
            .then((response) => {
                commit('setChapters', response.data)
            })
            .catch((error) => {
                console.log(error.response);
            });
        },

        getPolls({ state, commit }) {
            apiClient.get(`/projects/${state.selected_project}/polls/`, {
                headers: {
                    Authorization: 'Token ' + localStorage.getItem('token')
                }
            })
            .then((response) => {
                commit('setPolls', response.data)
            })
            .catch((error) => {
                console.log(error.response);
            });
        },

        async getTest({ state, commit, dispatch }, request) {
            state.points = null
            state.loading = true;
            state.test = null;
            state.testError = '';
            const { id, project } = typeof request === 'object' ? request : { id: request };
            try {
                if (!state.projects) await dispatch('getProjects');
                if (project) {
                    const choice = state.projects?.choices?.find(choice => String(choice.value) === String(project));
                    if (!choice) throw new Error('Unknown learning project');
                    commit('changeProject', choice.value);
                }
                if (!state.selected_project) throw new Error('Learning project is not available');
                const response = await apiClient.get(`/projects/${state.selected_project}/polls/${id}/`, {
                    headers: { Authorization: 'Token ' + localStorage.getItem('token') }
                });
                commit('setTest', response.data)
            } catch (_) {
                state.testError = 'Не удалось загрузить тест. Попробуйте ещё раз.';
            } finally {
                state.loading = false;
            }
        },

        endTest({ state }, data) {
            const answers = {}
            for(let i = 0; i < data.questions.length; i++) {
                const checked = data.questions[i].answer_choices.filter(x => x.checked).map(x => x.id);

                if(checked) {
                    answers[data.questions[i].id] = checked
                }
            }
            apiClient
            .post(`/projects/${state.selected_project}/poll-progress/`, {
                poll_id: data.id,
                answers: answers

            },
            {
                headers: {
                    Authorization: 'Token ' + localStorage.getItem('token')
                }
            })
            .then((response) => {
                if(response.data.is_completed) {
                    state.total_points = response.data.questions_count
                    state.points = response.data.correct_answers_count
                    state.is_succeded = response.data.is_succeded
                }
            })
            .catch((error) => {
                console.log(error.response);
            });
        },

        async getProjects({ commit }) {
            try {
                const response = await apiClient.get("/reports/study/filterset/", {
                    headers: {
                        Authorization: "Token " + localStorage.getItem("token"),
                    },
                });
                commit("setProjects", response.data);
            } catch (err) {
                // Если есть ошибка
                console.log(err);
            }
        },

        async addPollComment({}, data) {

            apiClient
            .patch(`/projects/tcode/poll-progress?poll_progress_id=${data.id}`, {
                comment: data.comment
            },
            {
                headers: {
                    Authorization: 'Token ' + localStorage.getItem('token')
                }
            })
            .then((response) => {
                console.log(response);
            })
            .catch((error) => {
                console.log(error.response);
            });
        }
    }
}
